import type { RouteRecordRaw } from "vue-router";
import { FeatureFlagName } from "@/services/fyApi";
import { routes as alliesRoutes } from "@/frontend/pages/fleets/[slug]/settings/allies/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "membership/",
    name: "fleet-settings-membership",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/membership.vue"),
    meta: {
      title: "fleets.settings.membership",
      needsAuthentication: true,
      customTitle: true,
    },
  },
  {
    path: "fleet/",
    name: "fleet-settings-fleet",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/fleet.vue"),
    meta: {
      title: "fleets.settings.fleet",
      needsAuthentication: true,
      access: ["fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "rsi/",
    name: "fleet-settings-rsi",
    component: () => import("@/frontend/pages/fleets/[slug]/settings/rsi.vue"),
    meta: {
      title: "fleets.settings.rsi",
      needsAuthentication: true,
      access: ["fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "squadrons/",
    name: "fleet-settings-squadrons",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/squadrons.vue"),
    meta: {
      title: "fleets.settings.squadrons",
      needsAuthentication: true,
      // Not gated on the fleet setting: this is where it is switched on.
      access: [
        "fleet:update",
        "fleet:squadrons:members:manage",
        "fleet:squadrons:manage",
        "fleet:manage",
      ],
      feature: FeatureFlagName.FLEET_SQUADRONS,
      featureScope: "fleet",
      customTitle: true,
    },
  },
  {
    path: "roles/",
    name: "fleet-settings-roles",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/roles.vue"),
    meta: {
      title: "fleets.settings.roles",
      needsAuthentication: true,
      access: ["fleet:roles:read", "fleet:roles:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "allies/",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/allies.vue"),
    meta: {
      title: "fleets.settings.allies",
      needsAuthentication: true,
      access: ["fleet:allies:read", "fleet:allies:manage", "fleet:manage"],
      feature: FeatureFlagName.FLEET_ALLIES,
      featureScope: "fleet",
      customTitle: true,
    },
    redirect: {
      name: alliesRoutes[0].name,
    },
    children: alliesRoutes,
  },
  {
    path: "notifications/",
    name: "fleet-settings-notifications",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/notifications.vue"),
    meta: {
      title: "fleets.settings.notifications",
      needsAuthentication: true,
      access: ["fleet:notifications:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "discord/",
    name: "fleet-settings-discord",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/discord.vue"),
    meta: {
      title: "fleets.settings.discord",
      needsAuthentication: true,
      access: ["fleet:notifications:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "calendar/",
    name: "fleet-settings-calendar",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/calendar.vue"),
    meta: {
      title: "fleets.settings.calendar",
      needsAuthentication: true,
      access: ["fleet:events:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "contracts/",
    name: "fleet-settings-contracts",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/contracts.vue"),
    meta: {
      title: "fleets.settings.contracts",
      needsAuthentication: true,
      access: ["fleet:contracts:manage", "fleet:manage"],
      customTitle: true,
    },
  },
  {
    path: "features/",
    name: "fleet-settings-features",
    component: () =>
      import("@/frontend/pages/fleets/[slug]/settings/features.vue"),
    meta: {
      title: "fleets.settings.features",
      needsAuthentication: true,
      access: ["fleet:manage"],
      customTitle: true,
    },
  },
];
